/** Overhead detection — keep in sync with server costsMarginPresent.isOverheadCost. */
export function isOverheadCostDescription(description: string | null | undefined): boolean {
  return /overhead|general\s*conditions/i.test(String(description || ''))
}
